import { render, staticRenderFns } from "./banner.pug?vue&type=template&id=662be473&scoped=true&lang=pug&"
import script from "./banner.ts?vue&type=script&lang=ts&"
export * from "./banner.ts?vue&type=script&lang=ts&"
import style0 from "./banner.scss?vue&type=style&index=0&id=662be473&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662be473",
  null
  
)

export default component.exports